import { useState } from "react";
import { downloadBackupApi } from "../api/backup";
import { useAuth } from "./";

export function useBackup() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { auth } = useAuth();

  const downloadBackup = async () => {
    try {
      setLoading(true);
      await downloadBackupApi(auth.token);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setError(error);
      throw error;
    }
  };

  return {
    loading,
    error,
    downloadBackup,
  };
}
